<div #tabtop (click)="initiated()">
  <p-tabs [value]="0">
    <p-tablist>
      <p-tab *ngFor="let tab of item.tabs; let $index = index" [value]="$index">
          {{tab.translation_key||tab.heading| translation|translationFromString | transformText :tab?.text_transform}}
         </p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel *ngFor="let tab of item.tabs; let $index = index" [value]="$index">
          <app-rendered
                        [childview]="item.childview || childview"
                        [paramprefix]="item.paramprefix"
                        [info]="info"
                        *ngFor="let it of tab.content" [item]="it"
                        [arr]="tab.content" [data]="data"
                        (deleteDataEvent)="delete($event)"
                        (openViewEvent)="openView($event)"
                        (moveHandler)="openMove()"
                        (openLinkEvent)="openLink($event)">

          </app-rendered>
        </p-tabpanel>
      </p-tabpanels>
  </p-tabs>
</div>
